import { MDBDatatable, MDBIcon } from 'mdb-react-ui-kit'
import React, { useEffect, useRef, useState } from 'react'
import DeleteAutherizedUser from '../../popups/securitymanager/DeleteAutherizedUser';
import PopupLoaderNew from '../../popups/PopupLoaderNew';

function AuthorizedUserDevice(props) {

    const [authUserList, setauthUserList] = useState([])
    const [deleteip, setdeleteip] = useState(false);
    const toggledelete = () => setdeleteip(!deleteip);
    const [authid, setAuthid] = useState("");
    const [isLoading, setisLoading] = useState(false);
    const addUserRef = useRef(null);

    function handleClick() {
        addUserRef.current.click();
    }

    const handleAuthUserDelete = (e, ipsInfo) => {
        e.preventDefault();
        console.log(JSON.stringify(ipsInfo));
        setAuthid(ipsInfo.id);
        toggledelete();
    }


    useEffect(() => {
        if (props.authorixedUser && props.authorixedUser.length > 0) {
            setauthUserList(props.authorixedUser);
        }

    }, [props.authorixedUser]);


    let processdrows = [];
    authUserList.map((auth) => {
        processdrows.push({
            userInfo: { ...auth },
            username: auth.user_name,
            deviceName: auth.Device_Name,
            authenticatedDate: auth.Authenticated_Date,
            browserName: auth.Browser_Name,
            delete: (
                <div className="d-flex align-items-center justify-content-center">
                    <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip">
                        <MDBIcon fas icon="times" color="primary" onClick={(e) => handleAuthUserDelete(e, auth)} className="mx-2 fs-5" />
                    </div>
                </div>
            ),

        })
    })

    const actionData6 = {
        columns: [
            { label: 'Username', field: 'username' },
            { label: 'Device Name', field: 'deviceName' },
            { label: 'Authenticated Date', field: 'authenticatedDate' },
            { label: 'Browser Name', field: 'browserName' },
            { label: 'Delete', field: 'delete', sort: false },
        ],
        rows: processdrows,
        // [
        //     {
        //         username: 'udeeswaraone@dynamic',
        //         deviceName: 'udeeswaraone@dynamic',
        //         authenticatedDate: 'March-13-2024 02:40:05',
        //         browserName: 'Chrome',
        //         delete: (
        //             <div className="d-flex align-items-center justify-content-center">
        //                 <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip">
        //                     <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
        //                 </div>
        //             </div>
        //         ),
        //     },
        //     // Add more rows as necessary
        // ],
    };

    return (
        <>
            <div className="actionbar"></div>

            <div className="SecutityTopViewPage1">
                <MDBDatatable className='actioncolumn' search hover data={actionData6} sortField="Username" sortOrder="asc" entries={50}/>
            </div>
            {deleteip && (
                <PopupLoaderNew
                    title={"Delete User"}
                    content={<DeleteAutherizedUser
                        id={authid}
                        onClose={toggledelete}
                        ref={addUserRef}
                        setIsloading={setisLoading}
                    />}
                    onShow={setdeleteip}
                    onClose={toggledelete}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}

        </>
    )
}

export default AuthorizedUserDevice
